import React from 'react'
import './WhatULearn.sass'
import b1 from './assets/b1.svg'
import b2 from './assets/b2.svg'
import b3 from './assets/b3.svg'
import b4 from './assets/b4.svg'
import b5 from './assets/b5.svg'
import b6 from './assets/b6.svg'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'

function WhatULearn({ onCallbackRequest }) {
  const data = [
    {
      title: 'Работаем круглосуточно',
      description: `Круглосуточная работа рецепции, прием звонков`,
      icon: b1,
    },
    {
      title: 'Развитая инфраструктура',
      description: `Наше общежитие находится в самом центре города`,
      icon: b2,
    },
    {
      title: 'Доступные цены',
      description: `Пожалуй, одни из самых выгодных цен для комфортного проживания в Мурманске`,
      icon: b3,
    },
    {
      title: 'Большой номерной фонд',
      description: `Более 20 номеров, доступных для бронирования`,
      icon: b4,
    },
    {
      title: 'Чистота и уют',
      description: `Бесплатная уборка номеров каждый день`,
      icon: b5,
    },
    {
      title: 'Доставка еды и продуктов',
      description: `Благодаря расположению в центре города, наше общежитие входит в зону всех популярных сервисов доставки продуктов и готовых блюд из ресторанов`,
      icon: b6,
    },
  ]
  return (
    <div id="benefits" name="benefits" className="EduBenefits">
      <div className="EduBenefits-Container DefaultContainer">
        <SectionTitle title={'Почему именно мы?'} />

        <div className="EduBenefits-TilesContainer">
          {data.map((d) => (
            <EduBenefitTile {...d} />
          ))}
        </div>
      </div>
    </div>
  )
}

function EduBenefitTile({ title, description, icon }) {
  return (
    <div className="EduBenefitTile">
      <div className="EduBenefitIcon">
        <img src={icon} alt={title} />
      </div>
      <h3 className="Title">{title}</h3>
      <p className="Body-Regular-1 Description">{description}</p>
    </div>
  )
}

export default WhatULearn
